import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import Icon from "../../../icon/icon.component.jsx"

const SupplierCreationButton = () => {
    return (
        <>
            <Link to="/imports/suppliers" className="btn btn-outline-primary">
                <Icon value="download" />
                <FormattedMessage
                    id="generic-listing.supplier.import-btn-text"
                    defaultMessage="Import"
                />
            </Link>

            <Link to="/suppliers/new" className="btn btn-primary">
                <Icon value={"plus-circle"}/>
                <FormattedMessage
                    id="generic-listing.supplier.create-btn-text"
                    defaultMessage="New Supplier"
                />
            </Link>
        </>
    )
}

export default SupplierCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/SupplierCreationButton.tsx